import moment from "moment";
import Vue from "vue";
import BoatRealVideo from "@/components/BoatRealVideo";
import ImgZoomWindow from "@/components/ImgZoomWindow";
import { getBoardVideo } from "@/api/api";
import { message } from "ant-design-vue";

function openStationWindow({
  wzProjectInfo,
  map,
  point,
  station,
  timeType,
  dataType,
  showChilds
}) {
  let iframe =
    `<iframe style="background-color: white" height="550px" width="600px" src="` +
    `//${wzProjectInfo.domain}/yangchen_station/?station_id=${
      station.station_id
    }&groups=${
      wzProjectInfo.top_group_id
    }&showMap=0&timep=${timeType}&data_type=${dataType}&t=${moment(
      station.TIME
    ).unix()}&show_childs=${showChilds}` +
    `" frameborder="0"></iframe>`;
  let content = `
        <div class="panel panel-primary">
            ${iframe}
        </div>`;
  let infoWindow = new AMap.InfoWindow({
    content: content,
    isCustom: false,
    width: 550,
    height: 600
  });
  // infoWindow.addEventListener("close", () => {});
  // map.openInfoWindow(infoWindow, point);
  infoWindow.open(map, point);
}

function openWzStationWindow({
  group_id,
  map,
  point,
  station,
  timeType,
  dataType,
  sensor_types
}) {
  if (!!point) {
    // 地图中心点像素值
    let centerPixel = map.lngLatToContainer(map.getCenter());
    // 点位像素值
    let pointPixel = map.lngLatToContainer(point);
    // 将点位移动到距离地图中心点x轴255px，y轴240px处，x 向右为正, y 向下为正
    map.panBy(
      255 - (pointPixel.x - centerPixel.x),
      240 - (pointPixel.y - centerPixel.y)
    );
  }
  let host =
    process.env.NODE_ENV === "production"
      ? ""
      : process.env.VUE_APP_DETAIL_HOST;
  let iframe =
    `<iframe style="background-color: white;margin: 12px 16px 0" height="730px" width="525px" src="` +
    `${host}/wz_station_detail/?station_id=${
      station.station_id
    }&group_id=${group_id}&showMap=1&timep=${timeType}&data_type=${dataType}&t=${moment(
      station.time
    ).unix()}&sensor_types=${sensor_types}` +
    `" frameborder="0"></iframe>`;
  let content = `
        <div class="panel panel-primary">
            ${iframe}
        </div>`;
  let infoWindow = new AMap.InfoWindow({
    content: content,
    isCustom: false,
    offset: new AMap.Pixel(0, -35)
  });
  // infoWindow.addEventListener("close", () => {});
  // map.openInfoWindow(infoWindow, point);
  infoWindow.open(map, point);
}

function openGfStationWindow({
  map,
  sn,
  point,
  dataType,
  timeType,
  sensor_types
}) {
  if (!!point) {
    // 地图中心点像素值
    let centerPixel = map.lngLatToContainer(map.getCenter());
    // 点位像素值
    let pointPixel = map.lngLatToContainer(point);
    // 将点位移动到距离地图中心点x轴255px，y轴240px处，x 向右为正, y 向下为正
    map.panBy(
      255 - (pointPixel.x - centerPixel.x),
      240 - (pointPixel.y - centerPixel.y)
    );
  }
  let host =
    process.env.NODE_ENV === "production"
      ? ""
      : process.env.VUE_APP_DETAIL_HOST;
  let iframe =
    `<iframe style="background-color: white;margin: 12px 16px 0" height="730px" width="525px" src="` +
    `${host}/wz_station_detail/?is_gf_station=1&sn=${sn}&showMap=1&timep=${timeType}&data_type=${dataType}&sensor_types=${sensor_types}&station_type=水质` +
    `" frameborder="0"></iframe>`;
  let content = `
        <div class="panel panel-primary">
            ${iframe}
        </div>`;
  let infoWindow = new AMap.InfoWindow({
    content: content,
    isCustom: false,
    offset: new AMap.Pixel(0, -35)
  });
  // infoWindow.addEventListener("close", () => {});
  // map.openInfoWindow(infoWindow, point);
  infoWindow.open(map, point);
}

async function openBoatVideoWindow(map, info, clickCallback) {
  try {
    let res = await getBoardVideo(info.station_id);
    let url = res.data.flv;
    let isOnline = res.data.online;
    if (isOnline) {
      // 117.038366, 36.597896 临时测试使用
      // let point = new AMap.LngLat(info.lng || 117.038366, info.lat || 36.597896);
      let point = new AMap.LngLat(info.lng, info.lat);
      const boatRealVideoContent = Vue.extend(BoatRealVideo);
      const sContentInstance = new boatRealVideoContent({
        propsData: {
          board_id: info.station_id,
          url: url
        }
      });
      sContentInstance.$mount();
      // sContentInstance.$on("clickInfo", e => {
      //   clickCallback();
      // });
      let infoWindow = new AMap.InfoWindow({
        zIndex: 1000,
        isCustom: false,
        content: sContentInstance.$el,
        offset: new AMap.Pixel(0, -72)
      });
      infoWindow.open(map, point);
      return infoWindow;
    } else {
      message.warning("设备不在线");
    }
  } catch (error) {
    console.log(error);
  }
}

function openTrackPointWindow({ info, sensortypes }) {
  let point = new AMap.LngLat(info.lng, info.lat);
  let tbodyContent = `
    <tr>
      <td>时间</td>
      <td>${info.time}</td>
      <td></td>
    </tr>
  `;
  for (let item of sensortypes) {
    tbodyContent += `
      <tr>
        <td>${item.label}</td>
        <td>${info[item.value]}</td>
        <td>${item.unit}</td>
      </tr>
    `;
  }
  let content = `
        <div class="track-point-window">
          <p class="title">${info.name}</p>
          <table class="table">
            <tbody>
              ${tbodyContent}
            </tbody>
          </table>
        </div>`;
  let infoWindow = new AMap.InfoWindow({
    content: content,
    isCustom: false,
    // offset: new AMap.Pixel(-2, -32)
  });
  infoWindow.open(map, point);
}

function openPointLayerWindow({ info, type }) {
  let point = new AMap.LngLat(info.lng, info.lat);
  const imgZoomWindowContent = Vue.extend(ImgZoomWindow);
  const contentInstance = new imgZoomWindowContent({
    propsData: {
      info: info,
      type: type
    }
  });
  contentInstance.$mount();
  let infoWindow = new AMap.InfoWindow({
    content: contentInstance.$el,
    isCustom: false,
    offset: new AMap.Pixel(0, -50)
  });
  infoWindow.open(map, point);
}

export {
  openStationWindow,
  openWzStationWindow,
  openGfStationWindow,
  openBoatVideoWindow,
  openTrackPointWindow,
  openPointLayerWindow
};
